import { FileList } from "./FilesList";
import { FilesShow } from "./FilesShow";

export const files = {
    list: FileList,
    show: FilesShow
}